import React, { useContext } from "react";
import { SidebarContext } from "../../Context/SidebarContext";
import Loader from "../../components/Loader";
import SubCategoryItem from "./SubCategoryItem";

const SidebarCategory = ({ parentCategory, isLoadingParent, isLoadingSub }) => {
  const { hide, isSidebarOpen } = useContext(SidebarContext);

  // Early return if sidebar is not open or data is loading
  if (!isSidebarOpen) return null;
  if (isLoadingParent || isLoadingSub) return <Loader />;

  return (
    <aside
      className={`w-[400px] hidden md:block border-r shrink-0 pr-6 pb-12 ${
        !isSidebarOpen ? "hidden" : ""
      }`}
    >
      <div className="flex w-full mb-3 justify-end">
        <button onClick={hide}>
          <i className="fas fa-times cursor-pointer"></i>{" "}
        </button>
      </div>
      <ul className="flex flex-col gap-3 font-semibold text-lg pl-[20px]">
        {parentCategory?.parentCategory?.map((item, index) => (
          <SubCategoryItem
            key={item._id || index}
            parentCategory={item}
            href={`/category/${item._id}`}
            showBtn={true}
          >
            {item.name}
          </SubCategoryItem>
        ))}
      </ul>
    </aside>
  );
};

export default SidebarCategory;
